import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import HomePage from './pages/HomePage';

function App() {
  return (
    <Router>
      <div data-component-path="client/src/App.jsx" data-component-line="8:6" data-component-id="client/src/App.jsx:8:6" className="min-h-screen">
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;